import { createTheme } from "@mui/material";
import { BrandColorsContemplary, BrandColorsprimary, NeutralColors, SystemColors, TSpacings } from "./theme.types";
import { Spacings, colors } from "./theme_values";


declare module '@mui/material/styles' {
	interface Theme {
		colors: {
			brand_colors_primary: BrandColorsprimary,
			brand_colors_contemplary: BrandColorsContemplary,
			neutral_colors: NeutralColors,
			system_colors: SystemColors
		};
		// spacing: TSpacings
	}

	interface ThemeOptions {
		colors: {
			brand_colors_primary: BrandColorsprimary,
			brand_colors_contemplary: BrandColorsContemplary,
			neutral_colors: NeutralColors,
			system_colors: SystemColors
		};
		// spacing: TSpacings
	}
}

export const theme = createTheme({
	colors: colors,
	// spacing: Spacings
});